import React from 'react';

import styles from './styles.module.scss';

export const Coupon = () => {
  const currentMonth = new Date()
    .toLocaleString('default', { month: 'long' })
    .toUpperCase();

  return (
    <div className={styles.wrapper}>
      <p className={styles.text}>Applied limited discount</p>
      <div className={styles.inputLabel}>
        <div className={styles.discountLabel}>#SLEEP{currentMonth}40</div>
        <div className={styles.discountInput}>up to 40%</div>
      </div>
      <p className={styles.text}> Coupon applied: 40% off your subscription.</p>
    </div>
  );
};
